import { useState } from 'react';
import type { DestinationContentSchema } from 'typings/destinations/DestinationContentSchema';

export type DestinationContentFieldErrors = {
    title?: string;
    body?: string;
};

export function useDestinationContentValidation(
    contents: DestinationContentSchema[],
    requiredFields: ('title' | 'body')[],
    options: {
        hasUniqueTitle?: boolean;
    } = {}
) {
    const [fieldErrors, setFieldErrors] = useState<Record<string, DestinationContentFieldErrors>>({});

    const validateFields = (newContents: DestinationContentSchema[] = contents) => {
        const errors: Record<string, DestinationContentFieldErrors> = {};

        newContents.forEach((content) => {
            if (!content.title && requiredFields.includes('title')) {
                errors[content.id] = {
                    title: 'Title is required',
                    ...errors[content.id],
                };
            } else if (
                options.hasUniqueTitle &&
                newContents.some((c) => c.title === content.title && c.id !== content.id)
            ) {
                errors[content.id] = {
                    title: 'Type must be unique',
                    ...errors[content.id],
                };
            }

            if (!content.body && requiredFields.includes('body')) {
                errors[content.id] = {
                    body: 'Body is required',
                    ...errors[content.id],
                };
            }
        });

        setFieldErrors(errors);

        return Object.values(errors).every((error) => !error);
    };

    return {
        hasErrors: Object.values(fieldErrors).some((error) => error),
        fieldErrors,
        validateFields,
    };
}
